import { Component, inject } from '@angular/core';
import { Form, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProfileService } from '../../service/profile-service';
import { Observable } from 'rxjs';
import { AuthService } from '../../service/auth-service';
import { ShippingDetails, User } from '../../models/user';
import { AsyncPipe, DatePipe, NgClass, NgIf, NgFor } from '@angular/common';
import { ProfileInfo } from '../../components/profile-info/profile-info';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImageService } from '../../service/image-service';
import { CITIES_BY_PROVINCE, COUNTRIES, PROVINCES } from '../../models/location.data';
import { ItemsLoading } from '../../components/items-loading/items-loading';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { faLock, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  imports: [FormsModule, ReactiveFormsModule, AsyncPipe, ProfileInfo, NgFor, ItemsLoading, FontAwesomeModule],
  templateUrl: './profile.html',
  styleUrl: './profile.scss'
})
export class Profile {
  private profileService = inject(ProfileService)
  private authService = inject(AuthService)
  private imageService = inject(ImageService)
  protected user$: Observable<User> = this.authService.user$ as Observable<User>;
  protected userForm: FormGroup;
  private snackBar = inject(MatSnackBar)
  protected loading: boolean = false
  protected passwordForm: FormGroup
  protected isPasswordChanging: boolean = false;
  protected deleting: boolean = false;
  protected deleteForm: FormGroup;
  private router = inject(Router)
  countries = COUNTRIES;
  provinces = PROVINCES;
  citiesByProvince = CITIES_BY_PROVINCE;
  availableCities: string[] = [];
  faSave = faSave
  faLock = faLock
  faTrash = faTrash
  isEmailPasswordUser = false;
  constructor() {
    // this.userForm = new FormGroup({
    //   name: new FormControl('', Validators.required),
    //   email: new FormControl('', [Validators.required]),
    //   contactNo: new FormControl('', Validators.required),
    //   address: new FormControl('', Validators.required),
    //   country: new FormControl('', Validators.required),
    //   province: new FormControl('', Validators.required),
    //   city: new FormControl('', Validators.required),
    //   postalCode: new FormControl('', Validators.required),
    //   id: new FormControl('')
    // })
    this.userForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required]),
      contactNo: new FormControl('', Validators.required),

      address: new FormControl('', Validators.required),
      country: new FormControl('Sri Lanka', Validators.required),
      province: new FormControl('', Validators.required),
      city: new FormControl({ value: '', disabled: true }, Validators.required),
      postalCode: new FormControl('', Validators.required),

      id: new FormControl('')
    });

    this.userForm.get('province')?.valueChanges.subscribe(province => {
      this.availableCities = this.citiesByProvince[province] || [];

      const cityControl = this.userForm.get('city');
      cityControl?.reset();
      cityControl?.enable();
      this.userForm.get('city')?.setValue(this.availableCities[0] || '');
    });

    this.userForm.get('email')?.disable();
    this.authService.user$.subscribe((user: User | null | undefined) => {
      if (user) {
        this.userForm.setValue({
          'name': user?.name || '',
          'email': user.email,
          'contactNo': user?.contactNo || '',
          'address': user.shippingDetails?.address || '',
          'country': user.shippingDetails?.country || '',
          'province': user.shippingDetails?.province || '',
          'city': user.shippingDetails?.city || '',
          'postalCode': user.shippingDetails?.postalCode || '',
          'id': user.id
        });
      }
    });

    this.passwordForm = new FormGroup({
      currentPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required)
    })

    this.deleteForm = new FormGroup({
      currentPassword: new FormControl(''),
    })

    this.loadProviderStatus();
  }

  async loadProviderStatus() {
    this.isEmailPasswordUser = await this.authService.isEmailPasswordUser();
  }

  selectProfile(file: File) {
    const id = this.userForm.get('id')?.value as string
    if (id && file) {
      this.loading = true
      this.imageService.uploadImage(file).then(url => {
        const user: Partial<User> = {
          profilePicture: url
        }
        this.profileService.updateUser(id, user).then(res => {
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    }
  }

  onDeleteAccount() {
    this.deleting = true;
    if (this.isEmailPasswordUser) {
      const currentPassword = this.deleteForm.get('currentPassword')?.value as string;
      if (!currentPassword) {
        this.deleting = false;
        this.snackBar.open("Current password is required!", 'Close', { duration: 5000 })
        return
      }
      this.authService.deleteAccount(currentPassword).then(res => {
        this.snackBar.open("Account Deleted!", 'Close', { duration: 5000 });
        this.router.navigate(['/sign-up'])
        this.deleting = false;
      }).catch(err => {
        this.snackBar.open("You can't delete your account!", 'Close', { duration: 5000 })
        this.deleting = false;
      })
    } else {
      this.authService.deleteGoogleAccount().then(res => {
        this.snackBar.open("Account Deleted!", 'Close', { duration: 5000 });
        this.router.navigate(['/sign-up'])
        this.deleting = false;
      }).catch(error => {
        this.snackBar.open("You can't delete your account!", 'Close', { duration: 5000 })
        this.deleting = false
      })
    }

  }

  // user = {
  //   fullName: 'John Doe',
  //   email: 'john@example.com',
  //   phone: '+1 234 567 890',
  //   address: '123 Main St',
  //   city: 'New York',
  //   zip: '10001',
  //   newPassword: '',
  //   currentPassword: ''
  // };

  onSubmit() {
    this.loading = true
    const id = this.userForm.get('id')?.value as string
    if (this.userForm.valid && id) {

      const shippingDetails: ShippingDetails = {
        fullName: this.userForm.get('name')?.value,
        address: this.userForm.get('address')?.value,
        country: this.userForm.get('country')?.value,
        province: this.userForm.get('province')?.value,
        city: this.userForm.get('city')?.value,
        postalCode: this.userForm.get('postalCode')?.value,
        contactNo: this.userForm.get('contactNo')?.value
      }
      const user: Partial<User> = {
        name: this.userForm.get('name')?.value,
        contactNo: this.userForm.get('contactNo')?.value,
        shippingDetails: shippingDetails,
        updatedAt: new Date().toISOString()
      }
      this.profileService.updateUser(id, user).then(res => {
        this.loading = false
        this.snackBar.open("Profile Updated!", 'Close', { duration: 5000 });
      }).catch(err => {
        this.loading = false
        this.snackBar.open("Profile Update Error!", 'Close', { duration: 5000 });
      })
    } else {
      this.loading = false
      this.snackBar.open("All field are required!", 'Close', { duration: 5000 });
    }
  }

  changePassword() {
    const currentPassword = this.passwordForm.get('currentPassword')?.value as string
    const newPassword = this.passwordForm.get('newPassword')?.value as string
    this.isPasswordChanging = true
    if (currentPassword === newPassword) {
      this.isPasswordChanging = false
      this.snackBar.open("Current Password and New Password Same!", 'Close', { duration: 5000 });
      return
    }
    this.authService.changePassword(currentPassword, newPassword).then(res => {
      this.snackBar.open("Password Changed!", 'Close', { duration: 5000 });
      this.isPasswordChanging = false
    }).catch(err => {
      this.isPasswordChanging = false
      this.snackBar.open("Password Changed Error!", 'Close', { duration: 5000 });
    })
  }
}
